"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreciseCalc = void 0;
const decimal_js_1 = require("decimal.js");
const isValidNumbers = (...numbers) => (numbers.every((number) => !Number.isNaN(+number)));
class PreciseCalc {
    static sum(a, b) {
        if (!isValidNumbers(a, b))
            return NaN;
        return +decimal_js_1.Decimal.sum(+a, +b).valueOf();
    }
    static sub(a, b) {
        if (!isValidNumbers(a, b))
            return NaN;
        return +decimal_js_1.Decimal.sub(+a, +b).valueOf();
    }
    static mul(a, b) {
        if (!isValidNumbers(a, b))
            return NaN;
        return +decimal_js_1.Decimal.mul(+a, +b).valueOf();
    }
    static div(a, b) {
        if (!isValidNumbers(a, b))
            return NaN;
        return +decimal_js_1.Decimal.div(+a, +b).valueOf();
    }
}
exports.PreciseCalc = PreciseCalc;
//# sourceMappingURL=precise-calc.js.map